<i18n lang='yml' src='../i18n/ManageContainerMetadata.yml'></i18n>
<template>
  <div v-if="loading">
    <loading-animation-vue></loading-animation-vue>
  </div>
  <div v-else>
    <div class="heading-block d-flex">
      <h4>
        <span class="program-name">{{ $t('manage_container_metadata', {name: name}) }}</span>
      </h4>
      <a @click.prevent="createMetadata()" id="scroll-target" class="btn btn-sm btn-primary ml-auto" href="#">
        <font-awesome-icon :icon="['fa', 'plus']"/>
        {{ $t('new_metadata') }}
      </a>
        
    </div>
    <h5 class="heading-page border-bottom">
      {{$t('add_metadata')}}
    </h5>
    <form @submit.prevent="submitContainerMetadata">
      <flash :message_type="message_type" :message_text="message_text"/>
      <div class="row">
        <div class="col-sm-12">
          <div class="border-bottom dotted">
            <p v-if="metadatas.length == 0" class="alert alert-info no-margin">{{ $t('no_metadatas_yet') }}</p>
            <div v-for="(metadata, index) in metadatas" v-bind:key="metadata.id" class="survey-question-wrapper mb-4">
              <div class="content-block col-sm-12 ">
                <div class="post-meta">
                  <ul class="list-inline list-annotation">
                    <li class="ml-auto">
                      <a class="btn btn-sm btn-danger ml-auto" @click.prevent="removeMetadata(metadata, index)" :title=" `${$t('remove')} ${$t('metadata')} ${metadata.title}`" :href="network_admin_containerType_index_path">
                        <font-awesome-icon :icon="['fa', 'times']" />
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="post-meta">

                  <div class="form-group row">
                    <div class="col-sm-12">
                      <label for="metadataTitleEnglish">{{ $t('new_metadata_title_en') }}</label>
              
                      <input v-model="metadata.title" type="text" class="form-control" id="metadataTitleEnglish">
                    </div>
                  </div>

                    <div v-for="lang in containerType.options_store.additional_languages" :key="lang" class="form-group row">
                    <div class="col-sm-12">
                      <label :for="`metadataTitle${lang}`">{{ $t(`new_metadata_title_${lang}`) }}</label>
                      <input v-model="metadata.additionalLanguageText[`${lang}`]" type="text" class="form-control" :id="`metadataTitle${lang}`">
                    </div>
                  </div>
                  
                  
                  <div class="form-group row">
                    <div class="col-sm-6">
                      <div class="checkbox">
                        <label>
                          <input type="checkbox" v-model="metadata.required" :value="1"> {{ $t('required_metadata') }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-6">
                      <div class="checkbox">
                        <label>
                          <input type="checkbox" v-model="metadata.visibleInListing" :value="1"> {{ $t('visible_in_listing') }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-6">
                      <label for="metadataType">{{ $t('metadata_types.header') }}</label>
                      <select id="metadataType" v-model="metadata.type" class="form-control">
                        <option :value="0">{{ $t('metadata_types.select_one') }}</option>
                        <option :value="1"> {{ $t('metadata_types.select_multiple') }}</option>
                        <option :value="2"> {{ $t('metadata_types.text') }}</option>
                        <option :value="3"> {{ $t('metadata_types.rich_text') }}</option>
                      </select>
                    </div>
                    <div class="col-sm-6" v-if="metadata.type === 2">
                      <label for="validationType">{{ $t('validation_types.header') }}</label>
                      <select id="validationType" v-model="metadata.validationType" class="form-control">
                        <option :value="null">None</option>
                        <option :value="0">{{ $t('validation_types.email') }}</option>
                        <option :value="1"> {{ $t('validation_types.date') }}</option>
                        <option :value="2"> {{ $t('validation_types.phone') }}</option>
                        <option :value="3"> {{ $t('validation_types.postal_code') }}</option>
                      </select>
                    </div>
                  </div>
                  <div v-if="isOptionMetadata(metadata)" class="form-group row">
                    <div class="col-sm-12">
                      <p class="label-p">{{ $t('define_options') }}</p>
                      <div class="margin-bottom" v-for="option in metadata.options" v-bind:key="option.id" >
                        <input v-model="option.answer_text" type="text" class="form-control"/>
                      </div>
                      <a @click.prevent="createOptions(metadata)" class="btn btn-sm btn-primary" href="#">
                        <font-awesome-icon :icon="['fa', 'plus']" />
                        {{ $t('add_option') }}
                      </a>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>

            </div>
          </div>

        </div>
        <div class="col-sm-12" id="footer_section">
          <div class="btn-row border-bottom light clearfix d-flex">
          
              <a @click.prevent="createMetadata" class="btn btn-sm btn-primary" href="#">
                <font-awesome-icon :icon="['fa', 'plus']"/>
                {{ $t('new_metadata') }}
              </a>
         
              <a @click.prevent="submitContainerMetadata" class="btn btn-sm btn-success" href="#">
                <font-awesome-icon :icon="['fa', 'save']" />
                {{ $t('save_metadata') }}
              </a>

              <a class="btn btn-sm btn-light ml-auto" :href="network_admin_containerType_index_path">
                <font-awesome-icon :icon="['fa', 'times']" />
                {{ $t('cancel') }}
              </a>
           
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
    import flash from '../../../../shared/flash_messages/components/Flash.vue';
    import { sendAjaxRequest } from '../../../../shared/typescripts/ajax.ts';

    export default {
        components: { flash },
        props: {
            api_path: { type: String },
            load_path: { type: String },
            available_roles: { type: String },
            container_type: {type: String},
            network_admin_containerType_index_path: {type: String},
            name: { type: String }
        },
        data() {
            return {
                loading: true,
                metadatas: [],
                roles: JSON.parse(this.available_roles),
                errors: [],
                message_text: [],
                message_type: "",
                containerType: {},
            };
        },
        methods: {
            createMetadata() {
                this.metadatas.forEach(metadata => {
                    metadata.position += 1;
                });
                this.metadatas.push({
                    position: 1,
                    id: null,
                    validationType: null,
                    required: false,
                    visibleInListing: true,
                    title: "",
                    additionalLanguageText: {},
                    type: 3,
                    options: [],
                    roles: []
                });
                if (this.metadatas.length > 1) {
                    this.scrollToEnd();
                }
            },

            removeUnsavedMetadata(index) {
              this.metadatas.forEach(metadata => {
                    metadata.position += 1;
                });

              this.metadatas.splice(index, 1);
            },

            createOptions(metadata) {
                metadata.options.push({
                    id: null,
                    answer_text: ""
                });
            },
            
            scrollToEnd: function() {
              $([document.documentElement, document.body]).animate({
                  scrollTop: $("#footer_section").offset().top
              }, 500);
            },
            scrollToTop: function() {
                window.scrollTo({top: 0, behavior: 'smooth'});
            },
            isOptionMetadata(metadata) {
                return [0, 1].includes(metadata.type);
            },

            validateResponseData() {
                this.message_text = []
                this.message_type = "error"
                let blank_title_count = 0
                
                this.metadatas.forEach(metadata => {
                    if (metadata.type > 3 || metadata.type < 0) {
                        this.message_text.push(this.$t("metadata_type_is_required"));
                    }
                    let isResponseTextEmpty = text => !text || text === null || text.trim() === "";
                    if (isResponseTextEmpty(metadata.title)) {
                        this.message_text.push(this.$t("metadata_is_required"));
                        blank_title_count += 1
                    }
                    if(this.containerType.options_store && this.containerType.options_store.additional_languages) {
                      this.containerType.options_store.additional_languages.forEach((lang) => {
                        if (isResponseTextEmpty(metadata.additionalLanguageText[`${lang}`])) {
                          this.message_text.push(this.$t(`metadata_${lang}_is_required`));
                            blank_title_count += 1
                        }
                      })
                    }
                });
                const titleValuesEn = [...new Set(this.metadatas.map(metadata => metadata.title ? metadata.title.toLowerCase() : ''))]; 
                this.uniqueTitles(titleValuesEn, blank_title_count)
                if(this.containerType.options_store && this.containerType.options_store.additional_languages) {
                  this.containerType.options_store.additional_languages.forEach((lang) => {
                    const titleValues = [...new Set(this.metadatas.map((metadata) => {
                      return metadata.additionalLanguageText[`${lang}`] ? metadata.additionalLanguageText[`${lang}`].toLowerCase() : '';
                    }))]
                    this.uniqueTitles(titleValues, blank_title_count)
                  })
                }
                
            },

            uniqueTitles(titleSet, blank_title_count) {
              if ((titleSet.length) < this.metadatas.length - (blank_title_count > 1? blank_title_count -1 : 0)) {
                this.message_text.push(this.$t("metadata_name_must_be_unique"))
              }
            },

            submitContainerMetadata() {
              
              this.validateResponseData()

              if (Object.keys(this.message_text).length > 0) {
                  event.preventDefault();
                  event.stopPropagation();
                  this.scrollToTop();
              } else {
                  let payload = {
                      survey_questions: []
                  };

                  this.metadatas.forEach(metadata => {
                      let question_data = {
                          position: metadata.position,
                          title: metadata.title,
                          additional_language_text: metadata.additionalLanguageText,
                          id: metadata.id,
                          type: metadata.type,
                          validation_type: metadata.validationType,
                          visible_in_listing: metadata.visibleInListing,
                          required: metadata.required,
                          answers: [],
                          roles: metadata.roles
                      };

                      metadata.options.forEach(option => {
                          question_data.answers.push({
                              id: option.id,
                              answer_text: option.answer_text
                          });
                      });

                      payload.survey_questions.push(question_data);
                  });

                  sendAjaxRequest('PUT', this.api_path, 'json', payload, this.submitMetadataSuccess)
                }
            },
            submitMetadataSuccess() {
                this.fetchQuestionData();
                this.message_type = "notice";
                this.message_text.push(this.$t("success_saving"));
                this.scrollToTop();
                this.loading = false;
            },

            loadSurveyData(data) {
              this.metadatas = [];
              data.forEach(item => {
                  let questionData = {
                      position: item.position,
                      id: item.id,
                      title: item.title,
                      additionalLanguageText: item.additional_language_text || {},
                      type: item.type,
                      required: item.required,
                      visibleInListing: item.visible_in_listing,
                      validationType: item.validation_type,
                      options: item.answers,
                      roles: item.roles
                  };
                  this.metadatas.push(questionData);
              });
            },

            fetchQuestionData() {
              const _vm = this;
              sendAjaxRequest('GET', this.load_path, 'json', {}, this.fetchQuestionDataSuccess)
            },

            fetchQuestionDataSuccess(response) {
              this.loadSurveyData(response);
              this.loading = false;
            },

            removeMetadata(survey_question, index) {
              const _vm = this;
              this.removeUnsavedMetadata(index)

              if(survey_question.id){
                let payload = []
                payload = survey_question.id

                sendAjaxRequest('DELETE', this.load_path, 'json', payload, this.removeMetadataSuccess, this.removeMetadataError)
              }
            },

            removeMetadataSuccess() {
              this.message_text.splice(0)
              this.message_type = 'notice'
              this.message_text.push(this.$t("successful_delete"));
              this.loading = false;
            },
            removeMetadataError() {
              this.message_type = "error";
              this.message_text.push(this.$t("error_deleting"));
              this.loading = false;
              console.log(response);
            }
        },
        mounted() {
            this.loading = true;
            this.fetchQuestionData();
            try {
              this.containerType = JSON.parse(this.container_type)
            }
            catch {
              console.log("Error parsing JSON")
            }
        }
    };
</script>
